<!--
 * @Author: your name
 * @Date: 2020-08-13 16:50:39
 * @LastEditTime: 2021-01-19 11:31:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/payment/component/EachPayment/index.vue
-->
<style scoped lang="sass">
.choosed
  color: var(--menu-primary-background-colour) !important

.each_payment
  display: flex
  align-items: center
  padding: 0 17PX
  border-bottom: 1PX solid #f1f2f3

  .img_box
    height: 36PX
    width: 55PX
    margin-right: 17PX
    background: #fff
    border-radius: 5PX

    .img
      height: 100%
      width: 100%

  .pay
    line-height: 58PX
    height: 58PX
    font-size: 14PX
    color: var(--menu-primary-text-colour)

</style>

<template lang="pug">
.each_payment_container
  div
    slot(name="button")
    slot(name="title")
  .each_payment(@click="emit")
    .img_box
      img(:src="src").img
    .pay(:class="{'choosed': choosed}") {{ name }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    src: {
      type: String
    },
    name: {
      type: String
    },
    choosed: {
      type: Boolean
    }
  }
})

class EachPayment extends Vue {
  emit() {
    this.$emit('clickItem')
  }
}

export default EachPayment
</script>
